<template>
    <content-loader
        view-box="0 0 400 42"
        class="sm:hidden"
        :primary-color="primaryColor"
    >
        <rect
            rx="8"
            ry="8"
            height="42"
            x="0"
            y="0"
            width="99"
        />
        <rect
            rx="3"
            ry="3"
            height="22"
            x="180"
            y="10"
            width="130"
        />
        <rect
            rx="50"
            ry="50"
            height="34"
            x="320"
            y="4"
            width="34"
        />
        <rect
            rx="50"
            ry="50"
            height="34"
            x="366"
            y="4"
            width="34"
        />
    </content-loader>
    <content-loader
        view-box="0 0 400 30"
        class="hidden sm:block md:hidden"
        :primary-color="primaryColor"
    >
        <rect
            rx="8"
            ry="8"
            height="30"
            x="0"
            y="0"
            width="70"
        />
        <rect
            rx="3"
            ry="3"
            height="16"
            x="250"
            y="8"
            width="80"
        />
        <rect
            rx="50"
            ry="50"
            height="24"
            x="345"
            y="4"
            width="24"
        />
        <rect
            rx="50"
            ry="50"
            height="24"
            x="376"
            y="4"
            width="24"
        />
    </content-loader>
    <content-loader
        view-box="0 0 400 25"
        class="hidden md:block lg:hidden"
        :primary-color="primaryColor"
    >
        <rect
            rx="4"
            ry="4"
            height="25"
            x="0"
            y="0"
            width="56"
        />
        <rect
            rx="3"
            ry="3"
            height="16"
            x="260"
            y="5"
            width="80"
        />
        <rect
            rx="50"
            ry="50"
            height="22"
            x="350"
            y="2"
            width="22"
        />
        <rect
            rx="50"
            ry="50"
            height="22"
            x="378"
            y="2"
            width="22"
        />
    </content-loader>
    <content-loader
        view-box="0 0 400 18"
        class="hidden lg:block"
        :primary-color="primaryColor"
    >
        <rect
            rx="3"
            ry="3"
            height="18"
            x="0"
            y="0"
            width="42"
        />
        <rect
            rx="2"
            ry="2"
            height="10"
            x="280"
            y="5"
            width="80"
        />
        <rect
            rx="50"
            ry="50"
            height="15"
            x="365"
            y="2"
            width="15"
        />
        <rect
            rx="50"
            ry="50"
            height="15"
            x="385"
            y="2"
            width="15"
        />
    </content-loader>
</template>

<script setup lang="ts">
    import { ContentLoader } from 'vue-content-loader';

    defineProps({
        primaryColor: {
            type: String,
            required: false,
            default: '#e5e5e5'
        }
    });
</script>
